import { ComputationOptions } from "./computeMaterialPrice";
import { OptimizedMachineTimes } from "./computeOptimizedMachineTimes";
import { OptimizedMaterialCosts } from "./computeOptimizedMaterialCosts";
import {
  computeQuoteRequestLinePrice,
  QuoteRequestLineForComputing,
} from "./computeQuoteRequestLinePrice";
import { AssemblyWithChildren } from "./groupQuoteRequestLinesByBatch";

export const computeChildrenQuoteRequestLineCosts = (
  {
    children,
    isQuotePrice = false,
    optimizedMachineTimes,
    optimizedMaterialCosts,
  }: {
    children: AssemblyWithChildren<QuoteRequestLineForComputing>[];
    isQuotePrice?: boolean;
    optimizedMachineTimes: OptimizedMachineTimes;
    optimizedMaterialCosts: OptimizedMaterialCosts;
  },
  options: ComputationOptions,
): {
  childrenTotalCost: number;
  childrenTotalMargin: number;
  childrenTotalPrice: number;
  childrenProcessesCost: number;
  childrenProductsCost: number;
  childrenMaterialCost: number;
} => {
  const {
    childrenTotalCost,
    childrenTotalMargin,
    childrenTotalPrice,
    childrenMaterialCost,
    childrenAddedValueCost,
    childrenProductsCost,
  } = children.reduce(
    (acc, child) => {
      const {
        assembly: {
          totalPrice,
          totalCost,
          totalMargin,
          addedValueProcessesCost,
          productsProcessesCost,
          materialCost,
        },
      } = computeQuoteRequestLinePrice(
        {
          quoteRequestLine: child.quoteRequestLine,
          isQuotePrice: isQuotePrice,
          optimizedMachineTimes,
          optimizedMaterialCosts,
        },
        options,
      );

      return {
        childrenTotalCost: acc.childrenTotalCost + totalCost,
        childrenTotalMargin: acc.childrenTotalMargin + totalMargin,
        childrenTotalPrice: acc.childrenTotalPrice + totalPrice,
        childrenMaterialCost: acc.childrenMaterialCost + materialCost,
        childrenAddedValueCost: acc.childrenAddedValueCost + addedValueProcessesCost,
        childrenProductsCost: acc.childrenProductsCost + productsProcessesCost,
      };
    },
    {
      childrenTotalCost: 0,
      childrenTotalMargin: 0,
      childrenTotalPrice: 0,
      childrenMaterialCost: 0,
      childrenAddedValueCost: 0,
      childrenProductsCost: 0,
    },
  );

  return {
    childrenTotalCost,
    childrenTotalMargin,
    childrenTotalPrice,
    childrenProcessesCost: childrenAddedValueCost,
    childrenMaterialCost,
    childrenProductsCost,
  };
};
